import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateDocumentStatus = createSelector(
  [(store: RootState) => store.documentCreate.createDocumentStatus],
  (status) => status
);
